<div class = "container">
    <div class="loading-overlay" *ngIf="loading">
        <mat-progress-spinner mode="indeterminate" diameter="40" strokeWidth="3"></mat-progress-spinner>
    </div>

    <form class = "card-form"  [formGroup]="motorForm" (ngSubmit)="submitForm()" autocomplete="off" novalidate>
        <div class="blue-top"></div>
        <div class="card-section top-section">
            <h1><b>{{LanguagePack.claimTitle}}</b></h1>
            <h2>{{LanguagePack.claimSubheading}}</h2>

            <mat-form-field appearance="outline" class="form-select">
                <mat-hint>{{LanguagePack.regHint}}</mat-hint>
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.regLabel}}</mat-label>
                <input matInput formControlName="reg" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['reg']">{{formErrors['reg']}}</mat-error>
            </mat-form-field>

            <div style="width: 100%;padding-top: 15px;"></div>

            <mat-form-field appearance="outline" class="form-select last-item" appFullYearDateFormat>
                <mat-label class="form-select-placeholder-unselected">{{LanguagePack.dateLabel}}</mat-label>
                <input matInput  [min]="minDate" [max]="maxDate" (blur)="logErrors()" [matDatepicker]="picker" readonly="true" (click)="picker.open()" formControlName="date">
                <mat-error *ngIf="formErrors['date']">{{formErrors['date']}}</mat-error>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker >
                </mat-datepicker>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.locationLabel}}</mat-label>
                <input matInput formControlName="location" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['location']">{{formErrors['location']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select">
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.emailClaimLabel}}</mat-label>
                <input matInput formControlName="email" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['email']">{{formErrors['email']}}</mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="form-select" >
                <mat-label class="form-select-placeholder-unselected" >{{LanguagePack.phoneClaimLabel}}</mat-label>
                <input matInput formControlName="phone" (blur)="logErrors()">
                <mat-error *ngIf="formErrors['phone']">{{formErrors['phone']}}</mat-error>
            </mat-form-field>

            <div class="row-div" style="padding-top: 50px; padding-bottom: 20px;">
                <button mat-stroked-button type="button" (click)="confirmCancel()">
                    <span class="button-text">{{LanguagePack.cancel}}</span>
                </button>
                <button mat-button type="submit" [disabled]="!motorForm.valid">
                    <span class="button-text">{{LanguagePack.saveContinue}}</span>
                </button>
            </div>
        </div>
    </form>
</div>
